import React from 'react';
import PropTypes from 'prop-types';
import { H3 } from 'components/atoms/Heading';
import Text from 'components/atoms/Text';
import * as styles from './TagWrapper.scss';
import Block from 'components/atoms/Block';

import { translate } from 'utils/translate';

const TagWrapper = ({ data }) => {

  const tags = data;

   /**
    * Get tag data and build it into correct format
    * returns a string of tags
    */
   function getTags(data){
    // assume it is a product page for now
    let tags = data.split(',').join(' #');
    return tags ? '#' + tags : '';
   }

   /**
    * Takes a string of tags and adds them to a block-paragraph,
    * returns the tag block
    */
   function returnTags(tags){
    const tagBlock = (
    <Block>
      <H3 className={styles.tagsHeader}>{translate('/product/tags')}</H3>
      <Text className={styles.tags}>{getTags(tags)}</Text>
    </Block>
    );

    return tags ? tagBlock : '';
   }

  return (
      returnTags(tags)
  );  
};



TagWrapper.PropTypes = {
  Data: PropTypes.any,
};

export default TagWrapper;